<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{ "DTC.HEADER" | translate }}</mat-card-title>
        <mat-card-subtitle>{{ "DTC.SUBHEADER" | translate }}</mat-card-subtitle>
        
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <mat-card class="control-bar">
                <mat-card-content class="controlcard">

                    <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{'DTC.TOOLTIP.ECU' | translate}}" matTooltipPosition="below">
                        <mat-label>{{ "DTC.SELECT" | translate }}</mat-label>
                        <mat-select [(value)]="ecu" [disabled]="disableSelect || periodicStarted" (selectionChange)="clearList()">
                            <mat-option *ngFor="let option of ecus" [disabled]="option.notAnOption" [value]="option.value"> {{ option.viewValue }}</mat-option>
                       </mat-select>
                    </mat-form-field>

                    <mat-button-toggle-group [(ngModel)]="statusMask" class="toggle" [disabled]="disableSelect || periodicStarted" (change)="clearList()">
                        <mat-button-toggle *ngFor="let item of options" [value]="item.id">{{item.viewValue | translate}}</mat-button-toggle>
                    </mat-button-toggle-group>

                    <div class="controlbutton">
                        <button 
                            class="controlbutton"
                            id="get" 
                            mat-raised-button
                            color="primary"
                            #tooltip="matTooltip"
                            matTooltip="{{'DTC.TOOLTIP.GET' | translate}}"
                            matTooltipPosition="below"
                            (click)="getDTCs()"
                            [disabled]="this.clicked || periodicStarted"
                        >
                        {{ "DTC.BTN_GET" | translate }}</button>

                        <ng-container *ngIf="this.roleService.isRole('Delete_DTC')">
                            <button 
                            class="controlbutton"
                            id="reset" 
                            mat-raised-button
                            color="warn"
                            #tooltip="matTooltip"
                            matTooltip="{{'DTC.TOOLTIP.RESET' | translate}}"
                            matTooltipPosition="below"
                            (click)="deleteDTCs()"
                            [disabled]="this.tableSet.data.length == 0 || periodicStarted || ecu === 0"
                            >
                            {{ "DTC.BTN_RESET" | translate }}</button>
                        </ng-container>

                        <button 
                            class="controlbutton"
                            id="cancel" 
                            mat-raised-button
                            color="accent"
                            #tooltip="matTooltip"
                            matTooltip="{{'DTC.TOOLTIP.CANCEL' | translate}}"
                            matTooltipPosition="below"
                            (click)="cancelRequest()"
                            [disabled]="!this.clicked"
                        >
                        {{ "DTC.BTN_CANCEL" | translate }}</button>

                        <ng-container *ngIf="statusMask == 9">
                            <button 
                            class="controlbutton"
                            id="repeat" 
                            mat-raised-button
                            [color]="color"
                            #tooltip="matTooltip"
                            matTooltip="{{'DTC.TOOLTIP.PERIODIC' | translate: { value: periodicTooltip } }}"
                            matTooltipPosition="below"
                            (click)="repeatRequest()"
                            [disabled]="this.clicked"
                            [class.spinner]="loadRequest && !this.clicked || this.clicked && periodicStarted"
                        >
                            {{'DTC.BTN_ZYK' | translate: { value: periodicStatus} }}</button>
                        </ng-container>
                        
                    </div>

                </mat-card-content>
            </mat-card>
            <mat-card class="table">
                <ng-container *ngIf="this.tableSet.data.length == 0 && this.clicked && !this.noDTCs">
                    <div class="loading">
                        <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner></div
                ></ng-container>
                <ng-container *ngIf="this.tableSet.data.length > 0 && this.clicked && !this.noDTCs">
                    <div class="loading">
                        <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner></div
                ></ng-container>
                <ng-container *ngIf="this.tableSet.data.length == 0 && this.noDTCs">
                    <div class="noDTC">
                        <a>{{ this.errorMessage }}</a></div
                ></ng-container>
                <ng-container *ngIf="this.tableSet.data.length > 0">
                    <table mat-table [dataSource]="this.tableSet">
                        <!-- Criticality Column -->
                        <ng-container matColumnDef="criticality">
                          <th mat-header-cell *matHeaderCellDef> {{ "DTC.TABLE.CRITICALITY" | translate }} </th>
                          <td mat-cell *matCellDef="let element">
                             <mat-chip [ngClass]="{
                                'info': element.criticality == 0,
                                'attention': element.criticality == 1,
                                'warning': element.criticality == 2,
                                'stop': element.criticality == 3,
                                'unused': element.criticality == 4
                             }"></mat-chip> 
                            </td>
                        </ng-container>
                      
                        <!-- ECU Column -->
                        <ng-container matColumnDef="ecu">
                          <th mat-header-cell *matHeaderCellDef> ECU ID </th>
                          <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ecuId == 0">
                                <mat-icon svgIcon="engine_alarm"></mat-icon>
                            </ng-container>
                            <ng-container *ngIf="element.ecuId == 120">
                                <mat-icon svgIcon="bagger_alarm"></mat-icon>
                            </ng-container>
                            {{element.ecuId}}</td>
                        </ng-container>
                      
                        <!-- Message Column -->
                        <ng-container matColumnDef="message">
                          <th mat-header-cell *matHeaderCellDef> {{ "DTC.TABLE.MESSAGE" | translate }} </th>
                          <td mat-cell *matCellDef="let element"> {{element.message}} </td>
                        </ng-container>
                      
                        <!-- SPN Column -->
                        <ng-container matColumnDef="spn">
                          <th mat-header-cell *matHeaderCellDef> SPN </th>
                          <td mat-cell *matCellDef="let element"> {{element.spn}} </td>
                        </ng-container>

                        <!-- FMI Column -->
                        <ng-container matColumnDef="fmi">
                            <th mat-header-cell *matHeaderCellDef> FMI </th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="getFmiTooltip(element.fmi)"> {{element.fmi}} </td>
                          </ng-container>

                        <!-- Timestamp Column -->
                        <ng-container matColumnDef="timestamp">
                            <th mat-header-cell *matHeaderCellDef #tooltip="matTooltip" matTooltip="{{ 'DTC.TOOLTIP.TIME' | translate}}" matTooltipPosition="below"> 
                                {{ "DTC.TABLE.TIMESTAMP" | translate }} 
                                <mat-icon class="info-icon" (click)="showTip()">help_outline</mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.timestamp != -1 ? element.timestamp : '-'}} {{element.timestamp != -1 ? 'h' : ''}}</td>
                          </ng-container>

                        <!-- Occurence Column -->
                        <ng-container matColumnDef="occurence">
                            <th mat-header-cell *matHeaderCellDef> {{ "DTC.TABLE.OCCURENCE" | translate }} </th>
                            <td mat-cell *matCellDef="let element"> {{element.occurence}} </td>
                          </ng-container>

                        <!-- Activity Column -->
                        <ng-container matColumnDef="activity">
                            <th mat-header-cell *matHeaderCellDef> {{ "DTC.TABLE.ACTIVITY" | translate }} </th>
                            <td mat-cell *matCellDef="let element"> {{element.activity}} </td>
                          </ng-container>

                        <!-- Click Column -->
                        <ng-container matColumnDef="click">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element"> <mat-icon>info_outline</mat-icon> </td>
                        </ng-container>

                        <!-- Troubleshoot Column -->
                        <ng-container matColumnDef="troubleshoot">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element"> 
                                <ng-container *ngIf="element.troubleshoot == undefined">
                                    <div class="loading" matTooltip="{{ 'DTC.TABLE.TROUBLE_LOAD' | translate}}">
                                        <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="element.troubleshoot != undefined">
                                    <div matTooltip="{{ 'DTC.TABLE.TROUBLE_DIS' | translate}}" [matTooltipDisabled]="element.troubleshoot">
                                        <button mat-icon-button
                                            [disabled]="!element.troubleshoot" 
                                            #tooltip="matTooltip"
                                            matTooltip="{{ 'DTC.TABLE.TROUBLE_A' | translate}}"
                                            matTooltipPosition="below"
                                            (click)="linkToTroubleshoot(element);  $event.stopPropagation();"
                                            >
                                            <mat-icon>troubleshoot</mat-icon> 
                                        </button>
                                        
                                    </div>
                                </ng-container>
                            </td>
                          </ng-container>

                        <!-- No Data Column -->
                        -<ng-container matColumnDef="empty-row">
                            <td mat-cell *matCellDef="let element"> No Data </td>
                            <div class="loading">
                                <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner></div>
                          </ng-container>
                      
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row (click)="showInfo(row)" [class.not-clickable]="noDetailMapping" *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                </ng-container>
            </mat-card>
        </div>
    </mat-card-content>
</div>
</mat-card>
